// @ts-nocheck
import React, { useEffect, useState } from 'react'
import styled from 'styled-components/macro'
import TypographyPro from 'themes/TypographyPro'
import TextFieldBase from 'components/common/TextField'

// todo: make 2 types of titles
const Title = styled(TypographyPro)`
	text-transform: uppercase;
	margin-bottom: 20px;
	color: var(--footerAndDarkBackgrounds);

	@media (max-width: 577px) {
		margin-top: 0;
		margin-bottom: 0;
	}
`

const TextField = styled(TextFieldBase)`
	@media (max-width: 577px) {
		position: absolute;
		top: 60px;
		z-index: 1;
		width: 95%;
		left: 50%;
		transform: translateX(-50%);
	}
`

const SearchField = ({ inputRef, conversationText, selectedPlace, onSuggestedItemEnterPressed, onSearchReset }) => {
	const [inputValue, setInputValue] = useState('')

	const clear = () => {
		setInputValue('')
		onSearchReset()
	}

	const searchFieldKeyDown = (e) => {
		if (e.keyCode === 13) {
			// Temporary workaround: Check if there are any autocomplete suggestions are shown
			// If there are any suggestions are shown - take the first one (as if user have clicked on it)
			const suggestedLocations = document.querySelectorAll('.pac-container .pac-item')
			if (suggestedLocations.length) {
				onSuggestedItemEnterPressed(suggestedLocations[0].innerText)
			}
		}
	}

	useEffect(() => {
		setInputValue(selectedPlace)
	}, [selectedPlace])

	return (
		<div>
			<div>
				<Title variant="h3" data-testid="store-locator-title">
					{conversationText.eCommerce.storeLocator.findYourNearestStore}
				</Title>
			</div>

			<TextField
				inputRef={inputRef}
				placeholder={conversationText.eCommerce.storeLocator.typeYourAddress}
				value={inputValue}
				onChange={(event) => setInputValue(event.target.value)}
				onResetValue={clear}
				inputProps={{
					'data-testid': 'user-address-input',
					onKeyDown: searchFieldKeyDown,
				}}
			/>
		</div>
	)
}

export default SearchField
